import * as React from 'react';
import PasswordResetForm from "./password_reset/auth_password_reset_form";
import {AuthWrapper} from "./share/auth_share_components";

interface IProps {
    handlePasswordResetSubmit: (values: any) => void;
}

const AuthPasswordResetComponent: React.FC<IProps> = (props) => {
    const {
        handlePasswordResetSubmit
    } = props;

    return (
        <React.Fragment>
            <AuthWrapper>
                <PasswordResetForm
                    onSubmit={handlePasswordResetSubmit}
                />
            </AuthWrapper>
        </React.Fragment>
    )

};

export default AuthPasswordResetComponent;



// WEBPACK FOOTER //
// ./src/presentation/component/auth/auth_password_reset.tsx